export default "__VITE_ASSET__pjWEKGZJ__"